import type React from 'react';
import { Controller, type Control, type FieldValues, type Path, type RegisterOptions } from 'react-hook-form';
import { FormControl, FormControlLabel, Radio, RadioGroup, type RadioGroupProps } from '@mui/material';

type RadioOption = {
  value: string;
  label: React.ReactNode;
  disabled?: boolean;
};

type FormRadioGroupFieldProps<TFieldValues extends FieldValues> = {
  name: Path<TFieldValues>;
  control: Control<TFieldValues>;
  options: RadioOption[];
  rules?: RegisterOptions<TFieldValues, Path<TFieldValues>>;
} & Omit<RadioGroupProps, 'name' | 'value' | 'defaultValue' | 'onChange'>;

export function FormRadioGroupField<TFieldValues extends FieldValues>({
  name,
  control,
  options,
  rules,
  ...radioGroupProps
}: FormRadioGroupFieldProps<TFieldValues>) {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field }) => (
        <FormControl component="fieldset">
          <RadioGroup {...radioGroupProps} value={field.value ?? ''} onChange={(_, value) => field.onChange(value)}>
            {options.map((option) => (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={<Radio />}
                label={option.label}
                disabled={option.disabled}
              />
            ))}
          </RadioGroup>
        </FormControl>
      )}
    />
  );
}
